import { getHubspotHutk } from './getHubspotHutk';

export function getHubspotContext() {
  return {
    hutk: getHubspotHutk(),
    pageUri: location.href,
    pageName: document.title,
  };
}
